export default __webpack_public_path__ + "static/media/Triggered_159x150.2a6fa059.png";